const Levels = require('./Levels');

function NOOP() {}

/**
 * A Logger is a component-specific logging source that pumps its events to a Log object.
 *
 * @classdesc
 */
class Logger {
  /**
   * Creates a Logger class specific to a component.
   *
   * @param {Log} logProcessor The object that handles all the log events coming
   *                    from this component.
   * @param {string} component The component that this logger is for.  Component
   *                    names should include dot separated namespace where appropriate.
   * @constructor
   */
  constructor(logProcessor, component) {
    if (typeof logProcessor.onLog !== 'function') {
      throw new Error('logProcessor did not have an onLog function.');
    }

    this.logProcessor = logProcessor;
    this.component = component;
  }

  /**
   * Configure the level that this component logger should output at.
   * @param {string} level the level to set
   * @returns {undefined}
   */
  setLevel(level) {
    /* Creates instance methods pointing to the NOOP function for
     * logging methods that should have no effect.
     */
    let dontLogThisLevel = true;
    for (let i = Levels.length - 1; i >= 0; --i) {
      if (Levels[i] === level) {
        dontLogThisLevel = false;
      }
      if (dontLogThisLevel) {
        this[Levels[i]] = NOOP;
      } else if (Object.prototype.hasOwnProperty.call(this, Levels[i])) {
        delete this[Levels[i]];
      }
    }
  }
}

// creates a method for each of the log levels.
Levels.forEach((level) => {
  Logger.prototype[level] = function logDelegate(...argsArray) {
    this.logProcessor.onLog(this.component, level, argsArray, Date.now());
  };
});

module.exports = Logger;
